import { render, staticRenderFns } from "./TaskDetailHeader.vue?vue&type=template&id=d1cd475e&scoped=true"
import script from "./TaskDetailHeader.vue?vue&type=script&lang=js"
export * from "./TaskDetailHeader.vue?vue&type=script&lang=js"
import style0 from "./TaskDetailHeader.vue?vue&type=style&index=0&id=d1cd475e&prod&lang=scss&scoped=true"
import style1 from "./TaskDetailHeader.vue?vue&type=style&index=1&id=d1cd475e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1cd475e",
  null
  
)

export default component.exports